import React, { useCallback, useEffect } from 'react';
import { pick } from 'ramda';
import { Table, TABLE_VIEW } from 'js/components/common/Table';
import { useTableData, useFetchFreeSpins, useFetchFreeSpinDetails } from './hooks';
import { useTranslations } from 'js/hooks/i18n';
import { useDynamicReducerSelector } from './store';
import style from './index.scss';

export const FreeSpinsBalanceBare = () => {
    const tableData = useTableData();
    const translate = useTranslations();
    const fetchFreeSpins = useFetchFreeSpins();
    const emptyTitle = translate('playtech.mobile.system.freespin-popup.no-available-spins');
    const fetchFreeSpinDetails = useFetchFreeSpinDetails();
    const { isLoading, error } = useDynamicReducerSelector(pick(['isLoading', 'error']));
    const onAccordionExpand = useCallback((id) => {
        fetchFreeSpinDetails(id);
    }, [fetchFreeSpinDetails]);

    useEffect(() => {
        fetchFreeSpins();
    }, [fetchFreeSpins]);

    return (
        <Table
            error={error}
            classNames={style}
            isLoading={isLoading}
            tableData={tableData}
            emptyTitle={emptyTitle}
            showTableBody={Boolean(!error)}
            tableRowView={TABLE_VIEW.ACCORDION}
            onAccordionExpand={onAccordionExpand}
        />
    );
};
